module.exports = __webpack_public_path__ + "static/media/home_zz4.00e0b865.png";